import { render } from "./cp_gifttip.vue?vue&type=template&id=765be3db"
import script from "./cp_gifttip.vue?vue&type=script&lang=js"
export * from "./cp_gifttip.vue?vue&type=script&lang=js"

import "./cp_gifttip.vue?vue&type=style&index=0&id=765be3db&lang=css"

import exportComponent from "E:\\Project\\HZY\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__